
import {Routes, Route, useParams, Link} from "react-router-dom";
import Header from "../../layouts/Header";
import Icon from "../../components/icon";
import Listing from "./Listing";
import Edit from "./Edit";
import Builder from "./Builder";
import Create from "./Create";
import Logs from "./Logs";
import Statistics from "./Statistics";


const JourneyManager = () => {
    const {id} = useParams()

    return (
        <>
            <Header
                icon="journey"
                title="Journey Manager"
                buttons={[
                    !id && window.location.pathname !== '/journeys/new' &&
                    <Link to={'new'} className="btn btn-sm btn-primary">
                        <Icon name="plus"/> <span>Create</span>
                    </Link>,
                ]}
            />
            <Routes>
                <Route index element={<Listing/>}/>
                <Route path="new" element={<Create/>}/>
                <Route path=":id" element={<Edit id={id}/>}/>
                <Route path=":id/limits" element={<Edit id={id}/>}/>
                <Route path=":id/builder" element={<Builder id={id}/>}/>
                <Route path=":id/logs" element={<Logs id={id}/>}/>
                <Route path=":id/statistics" element={<Statistics id={id}/>}/>


                <Route path="*" element={<div>Not Match</div>}/>
            </Routes>
        </>
    )
}

export default JourneyManager